/**
 * GEN-3223 — sinal "o servidor pediu o 2FA de acesso de novo" (a concessão da sessão venceu).
 *
 * Mora fora do `api.ts` porque quem escuta não é só a tela: o `useToast` também precisa saber, e
 * importar o cliente HTTP inteiro num componente de aviso puxaria axios, cookies e store junto.
 */
export const DTE_2FA_REQUIRED = "DTE_2FA_REQUIRED";
export const TWO_FACTOR_REQUIRED_EVENT = "taxly:2fa-required";

/**
 * Por quanto tempo depois do pedido os AVISOS DE ERRO são descartados. Quando a concessão vence, as
 * chamadas de /dte em voo voltam todas com o 403 `DTE_2FA_REQUIRED` quase juntas, e cada tela trata o
 * próprio 403 com um toast — vários dizendo "você não tem permissão", que é falso. Quem fala com o
 * usuário nesse momento é o modal do código.
 */
export const JANELA_SEM_AVISO_DE_ERRO_MS = 3000;

let ultimoPedido = 0;

/**
 * Chamado pelo `ApiCall` no 403 `DTE_2FA_REQUIRED`: avisa a tela e, se ela for mesmo pedir o código,
 * marca o momento. A tela que decide NÃO reabrir o modal (403 atrasado de uma chamada que saiu antes da
 * concessão) cancela o evento (`preventDefault`): aí ninguém vai falar com o usuário, e os avisos de
 * erro seguem aparecendo.
 */
export const pedirTwoFactorDeNovo = (scope: "dte") => {
  const evento = new CustomEvent(TWO_FACTOR_REQUIRED_EVENT, { detail: { scope }, cancelable: true });
  if (window.dispatchEvent(evento)) ultimoPedido = Date.now();
};

/** O servidor acabou de pedir o 2FA de novo? (o `ApiCall` marca ANTES de devolver o erro a quem chamou) */
export const acabouDePedirTwoFactor = (agora: number = Date.now()) =>
  agora - ultimoPedido < JANELA_SEM_AVISO_DE_ERRO_MS;

/** Só para testes. */
export const __zerarPedidoDeTwoFactor = () => {
  ultimoPedido = 0;
};
